(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["build-your-box"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-byo .reveal');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var success = document.querySelector('.cr-cd__success');
    if (success) { success.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var els = document.querySelectorAll('.cr-cd .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var success = document.querySelector('.cr-contact__success');
    if (success) {
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-gift-card"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cr-gift-card')) {
    customElements.define('cr-gift-card', class extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-design-index]'));
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
        this.current = 0;
        this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.current - 1));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.current + 1));
        this.thumbs.forEach((t) => t.addEventListener('click', () => this.show(Number(t.dataset.thumb))));

        this.form = this.querySelector('[data-form]');
        this.self = this.querySelector('[data-self]');
        this.recipient = this.querySelector('[data-recipient]');
        this.messageWrap = this.querySelector('[data-message-wrap]');
        this.when = this.querySelector('[data-when]');
        this.sendOn = this.querySelector('[data-send-on]');
        this.email = this.querySelector('[data-recipient-email]');
        this.message = this.querySelector('[data-message]');
        this.count = this.querySelector('[data-count]');
        this.errorEl = this.querySelector('[data-error]');
        this.submit = this.querySelector('[data-submit]');
        if (!this.form) return;

        this.self.addEventListener('change', () => this.toggleSelf());
        this.when.addEventListener('change', () => {
          const later = this.when.value === 'later';
          this.sendOn.hidden = !later;
          if (later && !this.sendOn.value) this.sendOn.value = this.sendOn.min;
        });
        this.message.addEventListener('input', () => (this.count.textContent = this.message.value.length));
        this.email.addEventListener('input', () => this.email.removeAttribute('aria-invalid'));
        this.amounts = Array.from(this.querySelectorAll('[data-amount]'));
        this.amounts.forEach((input) => input.addEventListener('change', () => {
          this.amounts.forEach((other) => {
            other.dataset.previousChecked = String(other.dataset.currentChecked === 'true' && other !== input);
            other.dataset.currentChecked = String(other === input);
          });
        }));
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.checkout(); });
      }

      show(index) {
        if (!this.cards.length) return;
        this.current = (index + this.cards.length) % this.cards.length;
        this.cards.forEach((c, i) => (c.hidden = i !== this.current));
        this.thumbs.forEach((t, i) => t.setAttribute('aria-pressed', String(i === this.current)));
      }

      toggleSelf() {
        const self = this.self.checked;
        this.recipient.hidden = self;
        this.messageWrap.hidden = self;
      }

      showError(text) {
        this.errorEl.textContent = text;
        this.errorEl.hidden = !text;
      }

      async checkout() {
        this.showError('');
        const variantId = Number(this.form.querySelector('[data-amount]:checked')?.value || this.dataset.variantId);
        const properties = {};
        const design = this.cards[this.current]?.dataset.designName;
        if (design) properties['Card design'] = design;
        const sender = this.querySelector('[data-sender-name]').value.trim();
        if (sender) properties['From'] = sender;

        if (!this.self.checked) {
          const email = this.email.value.trim();
          const valid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
          if (!valid) {
            this.email.setAttribute('aria-invalid', 'true');
            this.email.focus();
            this.showError(this.dataset.errorEmail);
            return;
          }
          properties['Recipient email'] = email;
          const name = this.querySelector('[data-recipient-name]').value.trim();
          if (name) properties['Recipient name'] = name;
          const msg = this.message.value.trim();
          if (msg) properties['Message'] = msg;
          if (this.when.value === 'later' && this.sendOn.value) {
            properties['Send on'] = this.sendOn.value;
          }
          properties['__shopify_offset'] = String(new Date().getTimezoneOffset());
        }

        this.submit.disabled = true;
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties }] }),
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || '');
          window.location.href = root + 'checkout';
        } catch (err) {
          this.showError(err.message || this.dataset.errorGeneric);
          this.submit.disabled = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-story-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cr-story-video')) {
    customElements.define('cr-story-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.sound = this.querySelector('[data-crsv-sound]');
        this.play = this.querySelector('[data-crsv-play]');
        this.video.muted = true;
        this.video.setAttribute('playsinline', '');

        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce) { this.video.removeAttribute('autoplay'); this.video.pause(); this.play.hidden = false; }

        this.sound?.addEventListener('click', () => {
          this.video.muted = !this.video.muted;
          this.sound.setAttribute('aria-pressed', String(!this.video.muted));
          if (!this.video.muted && this.video.paused) this.start();
        });
        this.play.addEventListener('click', () => this.start());
        this.video.addEventListener('click', () => (this.video.paused ? this.start() : this.stop()));

        // Only play while on screen — saves battery and data
        if ('IntersectionObserver' in window && !reduce) {
          this.io = new IntersectionObserver(([entry]) => (entry.isIntersecting ? this.start(true) : this.video.pause()), { threshold: 0.35 });
          this.io.observe(this);
        }
      }

      start(auto) {
        const p = this.video.play();
        this.play.hidden = true;
        if (p && p.catch) p.catch(() => { if (!auto) return; this.play.hidden = false; });
      }

      stop() { this.video.pause(); this.play.hidden = false; }

      disconnectedCallback() { this.io?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-badges"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-faqb .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-faqc .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.1, rootMargin:'0px 0px -50px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-closing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-faqx .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-faqh .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-closing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-close .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-cta"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-cta .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-hero .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-ing .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.cr-story .reveal');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-panel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-panel .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('.cr-video .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('is-visible');}); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    els.forEach(function(e){ obs.observe(e); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-benefits"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-subb');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-closing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-subx .reveal');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-subh');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-how"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-subw');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sub-plans"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var el = document.querySelector('.cr-subp');
    if (!el) return;
    if (!('IntersectionObserver' in window)) { el.classList.add('is-visible'); return; }
    var obs = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-visible'); obs.unobserve(en.target);} }); }, { threshold:0.15, rootMargin:'0px 0px -60px 0px' });
    obs.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-shorts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.cr-shorts .reveal');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    }

    document.querySelectorAll('.cr-shorts__mute-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('.cr-shorts__card');
        var video = card.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        if (video.muted) {
          card.removeAttribute('data-unmuted');
        } else {
          card.setAttribute('data-unmuted', '');
        }
      });
    });

    if ('IntersectionObserver' in window) {
      var videoEls = document.querySelectorAll('.cr-shorts__video');
      var playObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.4 });
      videoEls.forEach(function (video) { playObserver.observe(video); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trust-strip"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var revealEls = document.querySelectorAll('.cr-trust .reveal');
    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { observer.observe(el); });
  });

  } catch(e) { console.error(e); }
})();
})();
